module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/admin/breadcrumbs/breadcrumbs.component.scss
// module id = ./src/app/layouts/admin/breadcrumbs/breadcrumbs.component.scss
// module chunks = main